// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JTKm","badges":"styles_badges__Ucznn"};